<template>
  <ul
    class="infinite-lists"
    :style="{ maxHeight: chatHeight + 'px' }"
    v-infinite-scroll="infinite"
    infinite-scroll-disabled="busy"
  >
    <div :style="fsdfgy === 1 ? 'width: auto;height: 20px;' : 'width: auto;height: 16px;'"></div>
    <el-button class="up-btn" type="text" @click="refresh" :disabled="isUpOver">
      {{ isUpOver ? '已加载全部' : '点击加载' }} <i v-if="isUpOver === false" class="el-icon-d-arrow-left"></i>
    </el-button>
    <div :style="fsdfgy === 1 ? 'width: auto;height: 8px;' : 'width: auto;height: 16px;'"></div>
    <!-- 聊天记录 -->
    <template v-for="(item, index) in dialog">
      <li
        class="infinite-list-item"
        :key="index"
        :class="{right: item.record_user_type === 2}"
      >

        <div
        v-if="item.msg_type !== 'agree' && item.msg_type !== 'disagree' || item.msg_type !== 'vote' && item.content.votetype === 102">
         <img
            v-if="dialogUser[item.form_id] && dialogUser[item.form_id].avatar && dialogUser[item.form_id].avatar !==''"
            :src="dialogUser[item.form_id].avatar"
            class="user-avatar"
            :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''"
          />
         <avatar
          class="user-avatar"
          background-color="#204a9e"
          color="#fff"
          v-else-if="dialogUser[item.form_id] && dialogUser[item.form_id].name && dialogUser[item.form_id].name !== ''"
          :username="dialogUser[item.form_id].name"
          :size="48"
          :rounded="false"
          :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''">
          </avatar>
          <avatar
            class="user-avatar"
            v-else
            background-color="#204a9e"
            color="#fff"
            username="陌生人"
            :size="48"
            :rounded="false"
            :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''">
            </avatar>
         <!-- <img
            v-if="dialogUser[item.form_id] && dialogUser[item.form_id].avatar"
            :src="dialogUser[item.form_id].avatar"
            class="user-avatar"
            :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''"
          />
          <img :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''" v-else src="../assets/images/user_avatar2.png" class="user-avatar" />
        -->
        </div>
        <div
          class="list-item-content"
          :style="item.msg_type === 'agree' || item.msg_type === 'disagree' ? 'width: 100%;' : '' || item.msg_type === 'vote' ? 'width: 100%;' : ''"
        >
          <div class="dialog-info"
          v-if="item.msg_type != 'agree' && item.msg_type != 'disagree'"
          :style="item.msg_type === 'vote' && item.content.votetype === 102 ? 'display: none;' : ''">
            <template v-if="dialogUser[item.form_id] && dialogUser[item.form_id].type && dialogUser[item.form_id].type !== 1">
            <span style="font-size: 10px;">{{ item.msg_date }}</span>
              <span class="name" v-if="dialogUser[item.form_id] && dialogUser[item.form_id].name">{{
                dialogUser[item.form_id] ? dialogUser[item.form_id].name : '陌生人'
              }}</span>
              <span v-else>陌生人</span>
            </template>
            <template v-else>
              <span style="font-size: 10px;">{{ item.msg_date }}</span>
              <span class="name" v-if="dialogUser[item.form_id] && dialogUser[item.form_id].name">{{
                dialogUser[item.form_id] ? dialogUser[item.form_id].name : ''
              }}</span>
              <span v-else>陌生人</span>
            </template>
            <span v-if="dialogUser[item.form_id] && dialogUser[item.form_id].type">
              <span v-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks !== '' && JSON.parse(dialogUser[item.form_id].remarks).corp_name !== ''" class="corp-text">@{{ JSON.parse(dialogUser[item.form_id].remarks).corp_name }}</span>
              <span v-else-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks === ''" class="wx-text">@微信</span>
            </span>
          </div>
          <!-- 文本 -->
          <div class="msg" v-if="item.msg_type === 'text'">
            <div v-if="associative">
              <span v-if="isMask === true" v-html="item.content"></span>
              <span v-else v-html="strMarks(item.content, associative)"></span>
            </div>
            <div v-else>
              <span v-if="isMask === true" v-html="item.content"></span>
              <span v-else v-html="strMark(item.content, content)"></span>
            </div>
          </div>
          <div class="agree" v-else-if="item.msg_type === 'agree'" style="font-size: 14px;">
            <div style="font-size: 10px;">{{ item.msg_date }}</div>
            <img src="../assets/images/agree.png"  style="margin-right: 8px;"/>
            <span v-if="dialogUser[item.form_id] && is_group === 1">{{dialogUser[item.form_id].name}}</span>
            <span v-if="dialogUser[item.form_id] && dialogUser[item.form_id].type && is_group === 1">
              <span v-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks !== '' && JSON.parse(dialogUser[item.form_id].remarks).corp_name !== ''" class="corp-text">@{{ JSON.parse(dialogUser[item.form_id].remarks).corp_name }}</span>
              <span v-else-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks === ''" class="wx-text">@微信</span>
            </span>
            <span v-else>对方</span>同意会话存档内容
          </div>
          <div class="agree" v-else-if="item.msg_type === 'disagree'" style="font-size: 14px;">
            <div style="font-size: 10px;">{{ item.msg_date }}</div>
            <img src="../assets/images/disagree.png" style="margin-right: 8px;"/>
            <span v-if="dialogUser[item.form_id] && is_group === 1">{{dialogUser[item.form_id].name}}</span>
            <span v-if="dialogUser[item.form_id] && dialogUser[item.form_id].type && is_group === 1">
              <span v-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks !== '' && JSON.parse(dialogUser[item.form_id].remarks).corp_name !== ''" class="corp-text">@{{ JSON.parse(dialogUser[item.form_id].remarks).corp_name }}</span>
              <span v-else-if="dialogUser[item.form_id].type === 2 && dialogUser[item.form_id].remarks === ''" class="wx-text">@微信</span>
            </span>
            <span v-else>对方</span>不同意会话存档内容
          </div>
          <div class="toupia" v-if="item.msg_type === 'vote' && item.content.votetype === 102"  @click="touPiao2(item.form_id, item.msg_id)">
            <div style="font-size: 10px;">{{ item.msg_date }}</div>
            <span v-if="dialogUser[item.form_id] && dialogUser[item.form_id].name">
              <span>{{ dialogUser[item.form_id].name }}</span>参与了<span style="color: #0091FF;">投票</span>
            </span>
            <span v-else>未知用户参与了<span style="color: #0091FF;">投票</span></span>
          </div>
          <!-- 文件 -->
          <div class="file" v-else-if="item.msg_type === 'file'" @click="download(item.md5sum)">
            <div class="file-name">
              <div class="ellipsis">
                <span v-if="content === undefined">{{item.content.filename}}</span>
                <span v-else v-html="strMark(item.content.filename, content)"></span>
              </div>
              <div class="hioh">
                {{ item.size }}
              </div>
            </div>
            <img
              v-if="item.content.fileext === 'xmind'"
              src="../assets/images/icon-psd.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'mp3'"
              src="../assets/images/icon-mp3.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'pdf'"
              src="../assets/images/icon-pdf.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'doc' || item.content.fileext === 'docx'"
              src="../assets/images/icon-docx.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'xlsx' || item.content.fileext === 'xls' || item.content.fileext === 'csv'"
              src="../assets/images/icon-xlsx.png"
              width="40"
            />

            <img
              v-else-if="item.content.fileext === 'txt'"
              src="../assets/images/icon-txt.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'zip' || item.content.fileext === 'rar'"
              src="../assets/images/icon-zip.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'exe'"
              src="../assets/images/icon-psd.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'mp4' || item.content.fileext === 'avi' || item.content.fileext === 'm4a'"
              src="../assets/images/icon-mp4.png"
              width="40"
            />
             <img
              v-else-if="item.content.fileext === 'pptx' || item.content.fileext === 'ppt'"
              src="../assets/images/icon-ppt.png"
              width="40"
            />
            <img
              v-else-if="item.content.fileext === 'jpg' || item.content.fileext === 'png'"
              src="../assets/images/icon-jpg.png"
              width="40"
            />
            <img v-else src="../assets/images/icon-other.png" width="40" />
          </div>
          <!-- 语音 -->
          <div
            v-else-if="item.msg_type === 'voice'"
            class="voice-btn"
            :style="{ width: 30 + 3 * item.play_length + 'px' }"
            @click="play(item.content, index)"
          >
            <img
                v-if="item.record_user_type === 2"
                src="../assets/images/iocn-download.png"
                class="indownload02"
                @click="download01(item)"
              />
            <div class="yuyin">
              <!--   <img class="voice-icon fsdaf01" src="../assets/images/icon-voice.png" width="12" /> -->
              <img class="voice-icon" :src="item.content.mIcon" width="12" />
              <div v-if="item.record_user_type === 1" class="rwer">{{ item.play_length }}''</div>
              <div v-if="item.record_user_type === 2" class="rwer01">{{ item.play_length }}''</div>
            </div>
            <img
              v-if="item.record_user_type === 1"
              src="../assets/images/iocn-download.png"
              class="indownload"
              @click="download02(item.md5sum)"
            />
            <!--              @click="download02(item.md5sum)"-->
          </div>
          <!-- 视频 -->
          <div class="video" v-else-if="item.msg_type === 'video'">
            <video
            id="player"
            controls
            width="290px"
            :src="item.content.web_url"
            type="video/webm">
            </video>

            <img
              v-if="item.content.web_url === ''"
              src="../assets/images/iocn-download.png"
              class="indownload02"
              @click="download02(item.md5sum)"
            />
          </div>
          <!-- 图片/表情包 -->
          <ul style="margin-left: -40px;" v-else-if="item.msg_type === 'image' || item.msg_type === 'emotion'"
           @click="getImages(item.content)">
           <el-image
              v-if="item.content.web_url && item.content.web_url !== ''"
              style="width: 160px;"
              :src="item.content.web_url"
              :error-image-loader="handleError"
              :preview-src-list="srcList">
           </el-image>
            <el-image
              v-else
              style="width: 210px;box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);"
              src="../assets/images/image.png"
            >
              <div slot='error' class='image-slot'>
                文件过大，请点击按钮下载
              </div>
            </el-image>

            <!--             @click="download02(item.md5sum)"-->
            <img
              v-if="item.content.url_path == ''"
              src="../assets/images/iocn-download.png"
              class="indownload02"
              @click="download02(item.md5sum)"
            />
          </ul>
          <!-- 视频号 -->
          <ul v-else-if="item.msg_type === 'sphfeed'">
            <div class="vios" style="margin-left: -40px;">
              <img class="img" src="../assets/images/shipin.png" width="100%"/>
              <div class="title">
                <span v-if="content === undefined">{{item.content.sph_name}}</span>
                <span v-else v-html="strMark(item.content.sph_name, content)"></span>
              </div>
              <div class="desc">{{ item.content.feed_desc }}</div>
              <div class="bu">
                <img class="img" src="../assets/images/shipin.png" width="16px" />
                <div class="zi">视频号</div>
              </div>
            </div>
          </ul>
          <!-- 小程序 -->
          <ul class="info-card weapp" v-else-if="item.msg_type === 'weapp'">
            <li class="weapp_name ellipsis">{{ item.content.displayname }}</li>
            <li class="weapp_title ellipsis">
              <span v-if="content === undefined">{{item.content.title}}</span>
              <span v-else v-html="strMark(item.content.title, content)"></span>
            </li>
            <img class="weappA" src="../assets/images/weappA.png" />
            <li class="weapp_bottom">
              <img src="../assets/images/weappB.png" />
              <span>小程序</span>
            </li>
          </ul>
          <!-- 名片 -->
          <ul class="info-card visiting-card" v-else-if="item.msg_type === 'card'">
            <li class="info-title" v-if="item.content.corpname === '微信'|| item.content.corpname === '微信联系人'">
              <div class="fds">
                <div class="vnfuh">
                  <div style="display: flex;align-items: center;">
                    <img src="../../src/assets/images/wei.png" width="16px" height="16px"/>
                    <div style="margin-left: 4px;">微信联系人</div>
                  </div>
                  <div class="dsfss" v-if="item.content.user_name === ''">非企业客户</div>
                  <div class="dsfss" v-else-if="item.content.user_name !== '' && content" v-html="strMark(item.content.user_name, content)"></div>
                  <div class="dsfss" v-else>{{item.content.user_name}}</div>
                </div>
                <img v-if="item.content.user_avatar === ''" src="../assets/images/user_avatar2.png" width="40px" />
                <img v-else :src="item.content.user_avatar" width="40px" />
              </div>
              <div class="footer">个人名片</div>
            </li>
            <li class="info-title" v-else>
             <div class="fds">
                <div class="vnfuh">
                  <div class="dsfs">{{ item.content.corpname }}</div>
                  <div class="dsfss" v-if="item.content.user_name && content" v-html="strMark(item.content.user_name || '非企业客户', content)"></div>
                  <div class="dsfss" v-else>{{item.content.user_name}}</div>
                </div>
                <img v-if="item.content.user_avatar === ''" src="../assets/images/user_avatar2.png" class="img" />
                <img v-else :src="item.content.user_avatar" class="img" />
              </div>
              <div class="footer">企业微信名片</div>
            </li>
          </ul>
          <!-- 位置 -->
           <ul class="info-card location" v-else-if="item.msg_type === 'location'">
            <li class="location-text ellipsis">
              <img src="../../src/assets/images/map_bg.png" width="305px" height="160px">
              <img class="euio" src="../../src/assets/images/ditu1.png" >
              <div class="address">
                <div class="zi">
                  <span>{{item.content.title}}</span>
                </div>
                <div class="title">{{ item.content.address }}</div>
              </div>
            </li>
          </ul>
          <!-- 在线文档 -->
          <div class="info-card docmsg" v-else-if="item.msg_type === 'docmsg'" @click="goWen(item.content.link_url)">
            <div class="info-title">
              <div class="zai">
                <div class="title">
                  <span v-if="content === undefined">{{item.content.title}}</span>
                  <span v-else v-html="strMark(item.content.title, content)"></span>
                  <br />
                  <span class="sdfdas" v-if="dialogUser[item.form_id]">{{dialogUser[item.form_id].name}}</span>
                </div>
                <div class="img"><img src="../assets/images/zaixian.png" width="40px" height="40px"/></div>
              </div>
            </div>
            <div class="footer">
              在线文档
            </div>
          </div>
          <!-- 链接 -->
          <ul class="info-card link" v-else-if="item.msg_type === 'link'">
           <div class="wendang" v-if="item.content.link_url.includes('https://doc')" @click="goLink(item.content.link_url)">
            <div>
              <div class="info-title" >
                <span v-if="content === undefined">{{item.content.title}}</span>
                <span v-else v-html="strMark(item.content.title, content)"></span>
              </div>
              <div class="link-text" v-if="dialogUser[item.form_id]">{{ dialogUser[item.form_id].name || '陌生人'}}</div>
            </div>
            <li class="link-desc">
<!--                <img v-if="item.content.image_url" :src="item.content.image_url" width="40px" height="40px"/>-->
                <img v-if="item.content.image_url" src="../assets/images/link2.svg" width="40px" height="40px"/>
                <img v-else src="../assets/images/link2.svg" width="40px" height="40px"/>
              </li>
            </div>
            <div class="wendang" v-else-if="item.content.link_url.includes('https://work')">
              <div>
                <div class="info-title" >
                  <span v-if="content === undefined">{{item.content.title}}</span>
                  <span v-else v-html="strMark(item.content.title, content)"></span>
                </div>
                <div class="link-text" v-if="item.content.description !== ''">{{item.content.description}}</div>
              </div>
              <li class="link-desc">
<!--                <img v-if="item.content.image_url" :src="item.content.image_url" width="40px" height="40px"/>-->
                <img v-if="item.content.image_url" src="../assets/images/link2.svg" width="40px" height="40px"/>
                <img v-else src="../assets/images/link2.svg" width="40px" height="40px"/>
              </li>
            </div>
            <div v-else @click="goLink(item.content.link_url)">
              <li class="info-title">
                  <span v-if="content === undefined">{{item.content.title}}</span>
                  <span v-else v-html="strMark(item.content.title, content)"></span>
              </li>
              <li class="link-desc">
                <div class="link-text">{{ item.content.description }}</div>
<!--                <img v-if="item.content.image_url" :src="item.content.image_url" width="40" height="40px"/>-->
                <img v-if="item.content.image_url" src="../assets/images/link2.svg" width="40" height="40px"/>
                <img v-else src="../assets/images/link2.svg" width="40" height="40px"/>
              </li>
            </div>
          </ul>
          <!-- 聊天记录 -->
          <ul
            class="info-card chatrecord"
            v-else-if="item.msg_type === 'chatrecord'"
            @click="showChatrecord(item, associative)"
          >
            <li class="title">
              <span v-if="content" v-html="strMark(item.content.title + '的聊天记录', content)"></span>
              <span v-else>{{item.content.title}}的聊天记录</span>
            </li>
            <div class="ssa" v-if="item.content.item">
              <div  v-for="(record, index) in item.content.item.slice(0, 3)" :key="index">
                <div class="dasic" v-if="record.type === 'ChatRecordText'">
                  {{ JSON.parse(record.content).content }}
                </div>
                <template v-if="record.type === 'ChatRecordImage'">
                  [图片]
                </template>
                <template v-if="record.type === 'ChatRecordVideo'">
                  [视频]
                </template>
                <div class="dasic" v-if="record.type === 'ChatRecordSphFeed'">
                  [视频号]<span>{{JSON.parse(record.content).sph_name}}</span>
                </div>
                <template v-if="record.type === 'ChatRecordLocation'">
                  [位置]
                </template>
                <template v-if="record.type === 'ChatRecordWeapp'">
                  [小程序]
                </template>
                <template v-if="record.type === 'ChatRecordVote'">
                  [投票]
                </template>
                <template v-if="record.type === 'ChatRecordRedpacket'">
                  [红包]
                </template>
                <template v-if="record.type === 'ChatRecordExternal_redpacket'">
                  [互通红包]
                </template>
                <template v-if="record.type === 'chatrecord'">
                  [聊天记录]
                </template>
                <div class="dasic" v-if="record.type === 'ChatRecordLink'">
                  [链接]{{ JSON.parse(record.content).title }}
                </div>
                <div class="dasic" v-if="record.type === 'ChatRecordFile'">
                  [{{ JSON.parse(record.content).filename }}]
                </div>
                <div class="dasic"  v-if="record.type === 'ChatRecordMixed'">
                    <span v-for="(k, index) in JSON.parse(record.content).item" :key="index">
                      <span v-if="k.type === 'text'">{{JSON.parse(k.content).content}}</span>
                      <span v-else-if="k.type === 'image'">[图片]</span>
                      <span v-else-if="k.type === 'emotion'">[自定义表情]</span>
                    </span>
                </div>
              </div>
            </div>
          </ul>
          <!-- 填表 -->
          <ul class="info-card collect" v-else-if="item.msg_type === 'collect'">
            <li class="info-title">{{ item.content.title }}</li>
            <li>
              填表项：
              <span v-for="(row, index) in item.content.details" :key="index"
                >{{ row.ques }}、</span
              >
            </li>
          </ul>
          <!-- 投票 -->
          <div class="info-card vote" v-else-if="item.msg_type === 'vote' && item.content.votetype === 101">
            <div @click="touPiao(item.msg_id)">
              <div class="vote_title ellipsis" v-html="strMark(item.content.votetitle, content)"></div>
              <div class="vote_list">
                <div class="ellipsis" v-for="(voteitem, index) in item.content.voteitem.slice(0, 3)" :key="index">
                  <span></span>{{ voteitem }}
                </div>
              </div>
              <div class="vote_bottom">
                <img src="../assets/images/vote.png" />
                <span>投票</span>
              </div>
            </div>
          </div>
          <!-- 日程 -->
          <div class="info-card calendar" v-else-if="item.msg_type === 'calendar'" @click="getCalendar(item.msg_id)">
            <div class="info-title hiahd ellipsis">
              <span v-if="content === undefined">{{item.content.title}}</span>
              <span v-else v-html="strMark(item.content.title, content)"></span>
            </div>
            <div class="time ellipsis">
              {{ item.content.new_start_date }} - {{ item.content.new_end_date }}
            </div>
            <div class="place ellipsis">地点：{{ item.content.place || '-'}}</div>
            <div class="remarks ellipsis">备注：{{ item.content.remarks || '-'}}</div>
            <div class="info-footer">
              <img src="../assets/images/ri.png" width="12px" style=""/>
              <span class="rqwe">日程</span>
            </div>
          </div>
          <!-- 待办 -->
          <div class="info-card daiban" v-else-if="item.msg_type === 'todo'">
            <div class="info-title ellipsis" style="font-size: 16px;color: rgba(0, 0, 0, 0.85);">
              <span v-if="content" v-html="strMark(item.content.title, content)"></span>
              <span v-else>{{item.content.title}}</span>
            </div>
            <div class="dasic ellipsis">
              <span v-if="content" v-html="strMark(item.content.content, content)"></span>
              <span v-else>{{item.content.content}}</span>
            </div>
            <div class="info-footer">
              <img src="../assets/images/Upcoming.png" width="12"/>
              <span style="margin-left: 4px;font-size: 12px;color: rgba(0, 0, 0, 0.25);">待办</span>
            </div>
          </div>
          <!-- 会议 -->
          <ul class="info-card" v-else-if="item.msg_type === 'meeting'">
            <div v-if="item.content.meetingtype === 101" @click="meetShow(item.msg_id, item.msg_date)">
              <li class="info-title"><span v-html="strMark(item.content.topic, content)"></span></li>
              <li>
                {{ item.content.start_date }}
                至
                {{ item.content.end_date }}
              </li>
              <li>地点：{{ item.content.place || '-' }}</li>
              <li>备注：{{ item.content.remarks || '-' }}</li>
              <li class="info-footer">会议</li>
            </div>
            <div class="eqwe" v-else-if="item.content.meetingtype === 102" @click="meetShow(item.msg_id)">
              <div class="eqwe" v-if="status === 1">{{ stateText }}接受邀请<span style="color: #00FFFF;">{{ item.content.topic }}</span></div>
              <div class="eqwe" v-else-if="status === 2">{{ stateText }}拒绝邀请<span style="color: #00FFFF;">{{ item.content.topic }}</span></div>
              <div class="eqwe" v-else-if="status === 3">{{ stateText }}暂时接受邀请<span style="color: #00FFFF;">{{ item.content.topic }}</span></div>
            </div>
          </ul>
          <!-- 红包 -->
          <ul v-else-if="item.msg_type === 'redpacket'" style="margin-left: -40px;">
            <div class="redEnvelope">
              <img src="../assets/images/redEnvelope.png" />
              <div class="red_body">
                <span>{{item.content.wish}}</span>
              </div>
                <div class="red_bottom">
                  <!-- <div class="cvb" v-if="is_group === 1">
                    红包总金额：{{ item.content.totalamount / 100}}
                  </div> -->
                  <div v-if="is_group === 1" class="cvb02">红包个数：{{ item.content.totalcnt }}</div>
                </div>
            </div>
            </ul>
            <ul v-else-if="item.msg_type === 'external_redpacket'" style="margin-left: -40px;">
              <div class="redEnvelope">
                <img src="../assets/images/redEnvelope.png" />
                <div class="red_body">
                  <span>{{item.content.wish}}</span>
                </div>
                  <div class="red_bottom">
                    <div class="cvb" v-if="is_group === 1">
                    红包个数：{{ item.content.totalcnt }}
                    </div>
                    <div class="cvb01" v-if="is_group === 1 || is_group === 2" :style="is_group === 2 ? 'width: 100%;text-align: right;': ''">总金额：{{ item.content.totalamount / 100}}</div>
                  </div>
              </div>
            <!--<p style="margin-top:10px;text-align: left;">
              [{{ redpacketType[item.content.type] }}]
            </p> -->
          </ul>
          <!-- 音频存档消息 -->
          <ul
            class="info-card voice-msg"
            style="position: relative;background: #CBE9FF;"
            v-else-if="item.msg_type === 'meeting_voice_call'"
          >
            <div class="title">通话时长{{ item.Talk_time }}</div>
            <img src="../assets/images/dian.png" width="16" />
            <img
              v-if="item.content.share_data.length !== 0"
              src="../assets/images/jian.png"
              width="16"
              class="icon-download01"
              @click="download04(item)"
            />
            <img
              src="../assets/images/iocn-download.png"
              class="icon-download"
              width="16"
              @click="download(item.md5sum)"
            />
          </ul>
          <!-- 音频共享文档消息 -->
          <ul
            class="info-card voice-message"
            v-else-if="item.msg_type === 'voip_doc_share'"
            style="position: relative;"
            @click="getMess(item)"
          >
            <li class="file-wrap">
              <div class="file-name"><span>{{item.content.filename}}</span></div>
              <img
              v-if="FILETYPE.includes(item.content.suffix)"
              :src="require('../assets/images/icon-' + item.content.suffix + '.png')"
              width="40"
              />
              <img v-else src="../assets/images/icon-other.png" width="40"/>
            </li>
            <li class="info-footer">
              <img src="../assets/images/icon-circle-phone.png" width="16" />
              语音通话-演示文档
            </li>
          </ul>
          <!-- 混合消息 -->
          <div class="mixed" v-if="item.msg_type === 'mixed'">
            <div v-for="(mixed, index) in item.content.item" :key="index">
              <div class="text" v-if="mixed.type === 'text'" v-html="JSON.parse(mixed.content).content"></div>
              <div class="dasic" v-else-if="mixed.type === 'ChatRecordText'">
                {{  }}
              </div>
              <div  v-else-if="mixed.type === 'emotion' || mixed.type === 'image'">
                <el-image
                  v-if="mixed.content.path"
                  style="width: 210px;box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);"
                  :src="mixed.content.path"
                  :preview-src-list="srcList">
                  <div slot='error' class='image-slot'>
                    文件过大，请点击按钮下载
                  </div>
                </el-image>
                <el-image
                  v-else
                  style="width: 210px;"
                  src="../assets/images/image.png">

                </el-image>
                <!--                  v-if="mixed.content.path === ''"-->
                <!-- <img
                  src="../assets/images/iocn-download.png"
                  class="indownload02"
                  @click="download02(item.md5sum)"
                /> -->
              </div>
            </div>
          </div>
          <div class="msg" v-if="item.msg_type === 'revoke'">
            <span>{{ item.content }}</span>
          </div>
          <div class="revoke" v-if="item.msg_type === 'meeting_voice_call' && item.content.is_groupchat">
            <img src="../assets/images/disagree.png"  width="12"/>
            <span style="margin-left: 4px;">该语音通话为群聊中的通话</span>
          </div>
          <div class="revoke" v-if="item.is_recall === '1'">
            <img src="../assets/images/disagree.png"  width="12"/>
            <span style="margin-left: 4px;">此条信息已撤回</span>
          </div>
          <div style="width: auto;height: 20px;"></div>
          <!-- 音频存档 -->
          <el-dialog
            class="left"
            title="通话记录"
            :visible.sync="dialogVisible04"
            :before-close="hdfgd04"
            append-to-body
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="480px">
            <template v-if="share_data">
            <div v-if="share_data.length === 0" style="width: 100%;text-align: center;">暂无数据</div>
              <div class="yinp">
                <div class="bui" v-for="(item, index) in share_data" :key="index">
                  <div class="sdhu" v-if="!item.filename">
                    <div style="width:160px;">
                      <div style="margin-bottom: 8px;display: flex;align-items: center;">
                        <img src="../assets/images/qietu.png" width="16"/>
                        <span class="dfds">共享屏幕{{item.shareScreenNum}}次</span>
                      </div>
                    </div>
                    <div style="width:320px;">
                      <div class="said">{{item.staff_name || '陌生人'}}
                      <span class="mhu">{{item.starttime}}-{{item.endtime}}</span></div>
                    </div>
                  </div>
                  <div v-else class="sdhu">
                    <div style="width:160px;">
                      <div style="margin-bottom: 8px;display: flex;align-items: center;">
                        <img src="../assets/images/xiang.png" width="16"/>
                        <span class="dfds">演示文档</span>
                      </div>
                    </div>
                    <div style="width:320px;">
                      <div class="said">{{item.staff_name || '陌生人'}}
                      <span class="mhu">{{item.starttime}}-{{item.endtime}}</span></div>
                      <div class="wen" @click="getwen01(item)">
                        <div>
                          <div class="hgbn">{{item.filename}}</div>
                          <div class="sadf">{{item.filesize}}</div>
                        </div>
                          <img
                          v-if="FILETYPE.includes(item.filename.split('.')[1])"
                          :src="require('../assets/images/icon-' + item.filename.split('.')[1] + '.png')"
                          width="32px"
                          height="32px"
                        />
                        <img v-else src="../assets/images/icon-other.png" width="32px" height="32px" />
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-dialog>
          <!-- 发起人会议邀请 -->
          <el-dialog
            class="left"
            :title="meetTitle.topic"
            append-to-body
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="35%">
            <div class="ty-fa">
              <span>发起人: {{ people }}  ·  {{ time_sh }} </span>
            </div>
            <div class="ty-cont">
              <div><span>时间：</span><span>{{ meetTitle.start_date  }} ~ {{ meetTitle.end_date }}</span> </div>
              <div class="wen"><span>参与人：</span><span v-for="(record, index) in meetList" :key="index">{{ record }}  </span></div>
              <div class="wen"><span>地点：</span><span>{{ meetTitle.address || '-'}}</span></div>
              <div class="wen"><span>备注：</span><span>{{ meetTitle.remarks || '-'}}</span></div>
            </div>
            <div>
              <template>
                <el-tabs v-model="activeName">
                  <el-tab-pane :label="result" name="first">
                    <div>
                      <div class="ty-ask" style="margin-top: 19px;">接受<span style="margin-left: 85%;color: rgba(0, 0, 0, 0.45);">{{ percentage.length }}人</span></div>
                      <el-progress :percentage="accpt || 0"></el-progress>
                      <div class="hio"><span v-for="(record, index) in percentage" :key="index">{{ record }} </span></div>
                      <div class="ty-ask">暂定<span class="adas">{{ percentage3.length }}人</span></div>
                      <el-progress :percentage="zan || 0" ></el-progress>
                      <div class="hio"><span v-for="(record3, index) in percentage3" :key="index">{{ record3 }} </span></div>
                      <div class="ty-ask">拒绝<span class="adas">{{ percentage2.length }}人</span></div>
                      <el-progress :percentage="upaccpt || 0"></el-progress>
                      <div class="hio"><span v-for="(record2, index) in percentage2" :key="index">{{ record2 }} </span></div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane :label="county" name="second"><span v-for="(item, index) in w" :key="index">{{ item }} </span></el-tab-pane>
                </el-tabs>
              </template>
              <div class="foort" v-if="contData.status === 6">
                <img src="../assets/images/guo.png" width="12px" height="12px" />
                <span class="hui">会议已过期</span>
              </div>
              <div class="foort" v-else-if="contData.status === 5">
                <img src="../assets/images/qu.png" width="12px" height="12px" />
                <span class="hui">会议已取消</span>
              </div>
            </div>
          </el-dialog>
          <!-- 参与人会议邀请 -->
          <el-dialog
            class="left"
            :title="meetTitle.topic"
            append-to-body
            :visible.sync="dialosible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="35%">
            <div class="ty-fa">
              <span>发起人: {{ people }}  ·  {{ meetTitle.start_date }} </span>
            </div>
            <div class="ty-cont">
              <div><span>时间：</span><span>{{ meetTitle.start_date  }} ~ {{ meetTitle.end_date }}</span> </div>
              <div class="wen"><span>参与人：</span><span v-for="(record, index) in meetList" :key="index">{{ record }}  </span></div>
              <div class="wen"><span>地点：</span><span>{{ meetTitle.address || '-'}}</span></div>
              <div class="wen"><span>备注：</span><span>{{ meetTitle.remarks || '-'}}</span></div>
            </div>
            <div class="foort" v-if="meetStatus === 1">
              <img src="../assets/images/dui.png" width="12px" height="12px"/>
              <span class="hui">已接受</span>
            </div>
            <div class="foort" v-else-if="meetStatus === 3">
              <img src="../assets/images/wen.png" width="12px" height="12px"/>
              <span class="hui">暂时接受</span>
            </div>
            <div class="foort" v-else-if="meetStatus === 2">
              <img src="../assets/images/qu.png" width="12px" height="12px"/>
              <span class="hui">已拒绝</span>
            </div>
          </el-dialog>
          <!-- 日程 -->
          <el-dialog
            class="left"
            :title="riTitle"
            :visible.sync="dialosible01"
            append-to-body
            width="480px"
            :close-on-click-modal="false"
            :close-on-press-escape="false">
            <div class="ty-fa" style="display: flex;">
              <div class="wen">
                <span v-if="calTitle.creatorname !== ''">{{ calTitle.creatorname }}</span>
                <span v-else>-</span>
              </div>
              <div style="margin-left: 8px;">{{msgDDate}}</div>
              <!-- <div style="color: rgba(0, 0, 0, 0.85);margin-top:20px;">
                <span>{{ calTitle.new_start_date }} ~ {{ calTitle.new_end_date }}</span>
              </div> -->
            </div>
            <!-- <div style="height: 1px;background: hsla(231, 23%, 88%, 1);margin-top: 8px;"></div>-->
            <div class="ty-dfds">
              <div class="zu01">时间：<span>{{ calTitle.new_start_date || '-'}} - {{ calTitle.new_end_date }}</span></div>
              <div class="zu01">
                <div class="ijdias">成员：</div>
                <div v-if="calTitle.attendeename && calTitle.attendeename.length > 0" class="fdgfd">
                  <span
                  v-for="(record, index) in calTitle.attendeename"
                  :key="index">
                    <span class="gfd">{{ record }}<span v-show="index < calTitle.attendeename.length - 1">，</span></span>
                  </span>
                </div>
                <div v-else style="margin-left: -10px;">-</div>
              </div>
              <div class="zu ellipsis" style="margin-bottom: 8px;">地点：<span class="gfd">{{ calTitle.place || '-'}}</span></div>
              <div class="zu ellipsis">备注：<span class="gfd" style="font-size: 12px;color:hsla(0, 0%, 0%, 0.45);" v-if="calTitle.remarks !== ''">{{ calTitle.remarks }}</span>
                <span v-else>-</span>
              </div>
            </div>
          </el-dialog>
          <!---发起人投票 -->
          <el-dialog
            class="left"
            :title="touTitle"
            :visible.sync="tou"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="480px"
            max-height="300px"
            append-to-body
            @close="goTou">
            <div class="ty-fa" style="display: flex;">
              <div class="wen">
                <span v-if="calTitle.place !== ''">{{ touPeople}}</span>
                <span v-else>-</span>
              </div>
              <div style="margin-left: 8px;">{{msg_time.substring(0, 10)}}</div>
            </div>
            <div>
              <template>
                <el-tabs v-model="active01">
                  <el-tab-pane :label="result01 + '人已投票'" name="first">
                    <div class="ty-ask" style="margin-top: 12px;" v-for="(kk, index) in touXuan" :key="index">
                        {{ kk.vote }} {{ percentage5 }}
                      <span class="adas">{{ kk.num }}人</span>
                      <el-progress :percentage="kk.num_ratio" :stroke-width="2" style="font-size: 12px;"></el-progress>
                        <div class="sgks">
                          <div class="hio01">
                            <span v-for="(record, index) in kk.user_name_data" :key="index">{{ record }}<span v-show="index < kk.user_name_data.length - 1">，</span></span>
                          </div>
                        </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane style="color: #041D34;font-size: 13px;line-height: 20px;"
                  :label="county01 + '人未投票'" name="second">
                    <span v-for="(item, index) in wei" :key="index">{{ item }}<span v-show="index < wei.length - 1">，</span></span>
                  </el-tab-pane>
                </el-tabs>
              </template>
            </div>
          </el-dialog>
          <!---参与人投票 -->
          <el-dialog
            :visible.sync="tou2"
            :title="touTitle2"
            append-to-body
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="480px">
            <div class="ty-fa" style="display: flex;">
              <div class="wen">
                <span v-if="calTitle.place !== ''">{{ creatPeople}}</span>
                <span v-else>-</span>
              </div>
              <div style="margin-left: 8px;">{{msg_time2.substring(0, 10)}}</div>
            </div>
            <div v-for="(item, index) in can" :key="index">
              <div class="sdfeww" >
                <span>{{item.vote}}</span>
                <img v-if="people_data[item.vote]" src="../assets/images/gou.png" width="12" style="margin-left: 4px;"/>
              </div>
            </div>
          </el-dialog>
        </div>
      </li>
    </template>

    <!-- 转发聊天记录 -->
    <RecordView :chatrecord="chatrecord"
      :visible="firstRecord"
      :antistop="antistop"
      :associat="associative"
      :srcList_image="srcList_image"
      @close="closeDialog">
    </RecordView>
  </ul>
</template>
<script
  charset="utf-8"
  src="https://map.qq.com/api/gljs?v=2.exp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77"
></script>
<script>
import { FILEURL, FILETYPE } from '../config/constant.js'
// import { strMark } from '@/utils/util'
import BenzAMRRecorder from 'benz-amr-recorder'
import RecordView from './recordView'
import moment from 'moment'
import Avatar from 'vue-avatar'
const recordTypes = ['ChatRecordVideo', 'ChatRecordImage', 'ChatRecordFile']
import { downloadFile } from '../utils/downloadFile.js'
let amr = new BenzAMRRecorder()
let _self
const fileType = [
  'ppt',
  'xlsx',
  'docx',
  'mp3',
  'mp4',
  'txt',
  'html',
  'zip',
  'iso',
  'psd',
  'dwg',
  'pdf'
]
export default {
  components: {
    RecordView,
    Avatar
  },
  props: {
    msgId: {
      type: String,
      required: true
    },
    content: {
      type: String,
    },
    msgDay: {
      type: String,
    },
    associative: {
      type: String,
    },
    // 是否绑定在模态框中（不能查看转发聊天记录）
    isModal: {
      type: Boolean,
      default: false
    },
    fsdfgy: {
      type: Number
    },
    maskText: {
      type: String,
      default: ''
    },
    // 是否高亮全部敏感词
    isMask: {
      type: Boolean,
      default: true
    },
    // 默认内容审计高度
    chatHeight: {
      type: Number,
      default: 852
    }
  },
  data() {
    this.keywords = []
    return {
      // saveAs,
      downloadFile,
      FILETYPE,
      FILEURL,
      isDialog: true,
      show: false,
      contData: {},
      isShow: false,
      dialog: [],
      dialogUser: {},
      arrangement: {},
      userList: [],
      isUpOver: false,
      page: 1,
      upPage: 0,
      time_sh: '',
      chatrecord: {
        content: {}
      },
      is_group: '',
      busy: false,
      firstRecord: false,
      fileType,
      w: [],
      n: [],
      imgUrl: require('../../src/assets/images/icon-voice.png'),
      meetData: {},
      imgUrl01: require('../assets/images/Untitled.gif'),
      meetList: [],
      meetTitle: '',
      address: '',
      share_id: '',
      dialogVisible: false,
      dialosible: false,
      dialosible01: false,
      dialogVisible04: false,
      redpacketType: ['', '普通红包', '拼手气群红包', '激励群红包'],
      mIcon: require('../assets/images/icon-voice.png'),
      isloading: false,
      activeName: 'first',
      active01: 'first',
      percentage: [],
      percentage2: [],
      percentage3: [],
      percentage4: 0,
      percentage5: '',
      calTitle: {},
      result: '',
      result01: '',
      poll: 1,
      count: 0,
      county01: '',
      county: '',
      meetType: '',
      meetStatus: '',
      people: '',
      status: '',
      stateText: '',
      tou: false,
      touTitle: '',
      touPeople: '',
      msg_time: '',
      touXuan: [],
      wei: [],
      cardNames: '',
      cardImg: '',
      accpt: '',
      rwqrf: true,
      dkoskd: false,
      riTitle: '',
      upaccpt: '',
      zan: '',
      jdsi: [],
      tou2: false,
      can: [],
      creatPeople: '',
      msg_time2: '',
      touTitle2: '',
      people_data: {},
      share_data: [],
      antistop: '',
      shareChi: 0,
      msgDDate: '',
      srcList: [],
      srcList_image: [],
      upDay: '',
      downDay: '',
      upFlag:0,
      downFlag: 0,
      scrollLock: 0,
      isDownload:false
    }
  },
  filters: {
    timeFilter (val) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  mounted() {
    _self=this
    this.antistop = this.content
    if (this.fsdfgy === 1) {
      this.infinite()
    }
    this.upDay=this.msgDay
    this.downDay=this.msgDay

  },
  watch: {
  },
  methods: {
    handleError(error) {
      return '加载失败333';
    },
    location_click(item) {
      this.initMap()
    },
    initMap() {
      var center = new TMap.LatLng(39.984104, 116.307503)
      //初始化地图
      var map = new TMap.Map('container', {
        rotation: 20, //设置地图旋转角度
        pitch: 30, //设置俯仰角度（0~45）
        zoom: 12, //设置地图缩放级别
        center: center //设置地图中心点坐标
      })
    },
    strMark(str, mark) {
      if (mark === undefined) {
      } else {
        let titleString = str
        const replaceReg = new RegExp(mark, 'g' )
        const replaceString = '<span style="background: #faff85;">' + mark + '</span>'
        titleString = titleString.toString().replace(replaceReg, replaceString)
        return titleString
        // var regMark = mark.replace(/\[|\]|\(|\)|\*|\+|\?|\$/g, '\\$&')
        // let titleString = str.replace(/[\n\r]+/g, '')
        // const replaceReg = new RegExp(regMark, 'gi' )
        // const replaceString = '<span style="background: #faff85;">' + mark + '</span>'
        // titleString = titleString.toString().replace(replaceReg, replaceString)
        // return titleString
        // let chars = []
        // if (/^[a-zA-Z]*$/.test(str)) {
        //   var y = str.toLowerCase()
        //   chars = mark.split(',')
        //   chars.forEach(k => {
        //     y = y.replace(k, '<span style="background: #FAFF85FF;">' + k + '</span>')
        //   })
        //   return y
        // } else {
        //   chars = mark.split(',')
        //   chars.forEach(k => {
        //     str = str.toString().replace(k, '<span style="background: #FAFF85FF;">' + k + '</span>')
        //   })
        //   return str
        // }
      }
    },
    strMarks(str, marks) {
      let chars = []
      chars = marks.split(',')
      chars.forEach(k => {
        str = str.toString().replaceAll(k, '<span style="color: #ff0000;">' + k + '</span>')
      })
      return str
    },
    infinite() {

      if (this.scrollLock) return false
      this.scrollLock=true
      this.busy = true
      this.$api
        .post('/api/system/search/content/audit/details', {
          msg_id: this.msgId || this.maskText,
          type: 1,
          is_surplus: 1,
          page: this.page,
          msg_day: this.downDay,
          list_flag: this.downFlag
        //  is_all: sessionStorage.getItem('isAll') || 1
        })
        .then(res => {
          this.scrollLock=false
          if (res.data.length <10) {
            const lastMonthDate = new Date(this.downDay);
            lastMonthDate.setMonth(lastMonthDate.getMonth() + 1)
            this.downDay = moment(lastMonthDate).format('YYYY-MM-DD')
            this.downFlag = this.page
          }
          if (res.data.length > 0 ) {
            const dialog = res.data
            const arr = res.user_data
            dialog.forEach(async v => {
              // if (v.record_user_type!==2){
              //   v.record_user_type = 1
              // }
              // alert(v.record_user_type)
            // for (const v of dialog) {
              if (v.msg_type !== 'revoke') {
                try {
                  if (typeof v.content === 'string') {
                    v.content = JSON.parse(v.content)
                    if (!v.content.url_path.includes('http')) {
                      v.content.url_path = FILEURL + v.content.url_path
                    }
                  }
                } catch (error) {}
              }
              if (v.msg_type === 'voice') {
                // 音频
                v.content.mIcon = require('../assets/images/icon-voice.png')
                // if (v.content !== null) {
                //    if (!v.content.web_url || v.content.web_url === '') {
                //     } else if (!v.content.web_url.includes('https')) {
                //     v.content.web_url = FILEURL + data.path
                //   }
                // }
                  const md5 = v.content.md5sum
                  if (md5) {
                    const url = await this.getFile(md5)
                    v.content.web_url = url.path
                  }
              }
              if (v.msg_type === 'image' || v.msg_type === 'emotion') {
                  const md5 = v.content.md5sum
                  if (md5) {
                    const res = await this.getFile(md5)
                    if (res.path !== '') {
                      if (!res.path.includes('http')) {
                        v.content = {
                          url_path: FILEURL + res.path
                        }
                      } else {
                        v.content = {
                          web_url: res.path
                        }
                      }
                    } else {
                      v.content = {
                        url_path: ''
                      }
                    }
                  }
                  this.srcList.push(v.content.web_url)
              }
              if (v.msg_type === 'chatrecord') {
              }
              if (v.msg_type === 'video') {
                // if (v.content.web_url === '') {
                  const md5 = v.content.md5sum
                  if (md5) {
                    const url = await this.getFile(md5)
                    v.content.web_url = url.path
                  }
                // }
              }
              if (v.msg_type === 'file') {
                // if (v.content.web_url === '') {
                  const md5 = v.content.md5sum
                  if (md5) {
                    const url = await this.getFile(md5)
                    v.content.web_url = url.path
                  }
                // }
              }
              // if (v.msg_type === 'image') {
              //   if (v.content.web_url === '') {
              //     const md5 = v.content.md5sum
              //     if (md5) {
              //       const url = await this.getFile(md5)
              //       v.content.web_url = url.path
              //       this.srcList.push(v.content.web_url)
              //     }
              //   }
              // }
              // if (v.msg_type === 'emotion') {
              //   if (v.content.web_url === '') {
              //     const md5 = v.content.md5sum
              //     if (md5) {
              //       const url = await this.getFile(md5)
              //       v.content.web_url = url.path
              //       this.srcList.push(v.content.web_url)
              //     }
              //   }
              // }
              if (v.msg_type === 'card') {
                 for(var k in arr) {
                  if (v.form_id === k) {
                    // this.cardNames = arr[k].name
                    this.cardImg = arr[k].avatar
                  }
                }
              }
              if (v.msg_type === 'redpacket' || v.msg_type === 'external_redpacket') {
                v.content['isShow'] = false
              }
              if (v.msg_type === 'meeting') {
                for(var key in arr) {
                  if (v.content.meetingtype === 102) {
                    if (v.form_id === key) {
                      this.stateText = arr[key].name
                      if (v.content.status === 1) {
                        this.status = 1
                      } else if (v.content.status === 2) {
                        this.status = 2
                      } else if (v.content.status === 3) {
                        this.status = 3
                      }
                    }
                  }
                }
              }
              if (v.msg_type === 'mixed') {
                v.content.item.forEach(async item => {
                  if (item.type === 'image' || item.type === 'emotion') {
                    if (typeof item.content === 'string') {
                      const list = JSON.parse(item.content)
                      const md5 = JSON.parse(item.content).md5sum
                      if (md5) {
                        const data = await this.getFile(md5)
                        if (!data.path.includes('https')) {
                          data.path = FILEURL + data.path
                          list.path = data.path
                        } else {
                          list.path = data.path
                        }
                      }
                      item.content = list
                      this.srcList.push(item.content.path)
                    }
                  }
                })
              }
              if (v.msg_type === 'calendar') {
              }
              if (v.msg_type === 'meeting_voice_call') {
                // const a = v.content
                // if (a.sharescreendata) {
                //   this.share_id = a.sharescreendata[0].share
                // } else {
                //     this.share_id = ''
                // }
              }
            })

            var that = this
            setTimeout(function() {
              that.dialog = that.dialog.concat(dialog)
            }, 500)
            // this.dialog = this.dialog.concat(dialog)
            // this.dialog = this.dialog.concat(dialog)
            const user = res.user_data
            // for (let k in user) {
            //   if (user[k].length === 0) {
            //     user[k] = {
            //       name: '未知用户'
            //     }
            //     user[k] = JSON.stringify(user[k])
            //   }
            // }
            this.dialogUser = Object.assign(this.dialogUser, user)
            this.arrangement = res.arrangement
            this.is_group = res.is_group
          } else {
            //this.busy = true
            // this.$message.info('没有更多数据了！')
          }
          this.page = this.page + 1

        })
        this.busy = false
    },
    refresh() {
      if (this.isloading) {
        return false
      } else {
        this.isloading = true
      }
      this.busy = false
      this.upPage = this.upPage + 1
      this.$api
        .post('/api/system/search/content/audit/details', {
          msg_id: this.msgId,
          type: 2,
          is_surplus: 1,
          page: this.upPage,
          msg_day: this.upDay,
          list_flag: this.upFlag
        //  is_all: sessionStorage.getItem('isAll') || 1
        })
        .then(
          res => {
            if (res.data.length <10) {
              const lastMonthDate = new Date(this.upDay);
              lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
              this.upDay = moment(lastMonthDate).format('YYYY-MM-DD')
              this.upFlag = this.upPage
            }
            if (res.data.length > 0 ) {
              let dialog = []
              const data = JSON.parse(JSON.stringify(res.data))
              dialog = data.reverse()
              dialog.forEach(async v => {
                if (v.msg_type !== 'revoke') {
                  try {
                    if (typeof v.content === 'string') {
                      v.content = JSON.parse(v.content)
                      if (!v.content.url_path.includes('http')) {
                        v.content.url_path = FILEURL + v.content.url_path
                      }
                    }
                  } catch (error) {}
                }
                if (v.msg_type === 'image' || v.msg_type === 'emotion') {
                  const md5 = v.content.md5sum
                  if (md5) {
                    const res = await this.getFile(md5)
                    if (res.path !== '') {
                      if (!res.path.includes('http')) {
                        v.content = {
                          url_path: FILEURL + res.path
                        }
                      } else {
                        v.content = {
                          web_url: res.path
                        }
                      }
                    } else {
                      v.content = {
                        url_path: ''
                      }
                    }
                    this.srcList.push(v.content.url_path)
                  }

                  if(v.content.web_url) this.srcList.push(v.content.web_url)

                }

                if (v.msg_type === 'image') {
                  // if (v.content.web_url === '') {
                    const md5 = v.content.md5sum
                    if (md5) {
                      const url = await this.getFile(md5)
                      v.content.web_url = url.path
                      this.srcList.push(v.content.url_path)
                    }
                  // }

                   if(v.content.web_url) this.srcList.push(v.content.web_url)
                }

                if (v.msg_type === 'emotion') {
                  // if (v.content.web_url === '') {
                    const md5 = v.content.md5sum
                    if (md5) {
                      const url = await this.getFile(md5)
                      v.content.web_url = url.path
                      this.srcList.push(v.content.url_path)
                    }
                  // }
                }
                if (v.msg_type === 'voice') {
                  // 音频
                  v.content.mIcon = require('../assets/images/icon-voice.png')
                  // if (v.content !== null) {
                  //   if (!v.content.web_url || v.content.web_url === '') {
                  //     } else if (!v.content.web_url.includes('https')) {
                  //     v.content.web_url = FILEURL + data.path
                  //   }
                  // }
                  const md5 = v.content.md5sum
                  if (md5) {
                    const url = await this.getFile(md5)
                    v.content.web_url = url.path
                  }
                }
                if (v.msg_type === 'video') {
                  // if (v.content.web_url === '') {
                    const md5 = v.content.md5sum
                    if (md5) {
                      const url = await this.getFile(md5)
                      v.content.web_url = url.path
                    }
                  // }
                }
                if (v.msg_type === 'card') {
                  this.cardname(v.content.userid).then(res => {
                    v.content.userid = res.name || '未知'
                  })
                }
                if (v.msg_type === 'mixed') {
                  v.content.item.forEach(async item => {
                    if (item.type === 'image' || item.type === 'emotion') {
                      if (typeof item.content === 'string') {
                        const md5 = JSON.parse(item.content).md5sum
                        if (md5) {
                          // item.content = await this.getFile(md5)
                          const data = await this.getFile(md5)
                          // if (!data.path.includes('http')) {
                          //   data = FILEURL + data
                          // }
                          item.content = data
                        }
                      }
                    }
                  })
                }
              })
              this.dialog = dialog.concat(this.dialog)
              const user = res.user_data
              // for (let k in user) {
              //   if (user[k].length === 0) {
              //     user[k] = {
              //       name: '未知用户'
              //     }
              //     user[k] = JSON.stringify(user[k])
              //   }
              // }
              this.dialogUser = Object.assign(this.dialogUser, user)
              for (var i = 0; i < this.dialogUser.length; i++) {
                // str += parseInt(name[i].charCodeAt(0), 10).toString(16)
              }
              // return '#0c' + str.slice(1, 2)
            } else {
              this.isUpOver = true
              // this.busy = true
              // this.$message.info('没有更多数据了！')
            }
            this.isloading = false
          },
          () => {
            this.isloading = false
          }
        )
    },
    getFileType(fileName) {
      if (fileName === undefined || fileName === '') {
      } else {
        const file = fileName.split('.')
        return file[file.length - 1]
      }
    },
    hdfgd04() {
      this.dialogVisible04 = false
    },
    play(content, index) {
      if(this.isDownload) {
        this.isDownload = false
        return true
      }
      const that = this
      const url = content.web_url
      amr.stop()
      amr = new BenzAMRRecorder()
      this.playing(url, index)
      amr.onEnded(function() {
        that.dialog[index].content.mIcon = require('../assets/images/icon-voice.png')
        // 'http://chatdata-api.leysen1855.com:8080/upload_logo/20220113095733563541642039053.png'
      })
    },
    playing(url, index) {
      this.dialog[index].content.mIcon = require('../assets/images/Untitled.gif')
      amr.initWithUrl(url)
        .then(function() {
          amr.play()
        })
        .catch(() => {
          this.dialog[index].content.mIcon = require('../assets/images/icon-voice.png')
          this.$message.info('语音不存在或者已删除！')
        })
    },
    getMess(item) {
      window.open(item.content.web_url)
    },
    async cardname(val) {
      // const res = await this.$api.get('/search/staff/user', {
      // const res = await this.$api.get('/user/search-staff', {
      //   type: 1,
      //   user_id: val
      // })
      // // if (res.data.length) {
      // // return res.msg[0]
      // if (res.msg.length) {
      //   return res.msg[0]
      // } else {
      //   return {}
      // }
    },
    showChatrecord(item, associative) {
      console.log('bbb')
      if (this.isModal) {
        this.$message.info('会话记录详情请到内容审计查看')
      } else {
        this.chatrecord = item.content
        try {
          this.chatrecord = {}
          const data = JSON.parse(JSON.stringify(item))
          data.content.item.forEach(async v => {
            if (v.type === 'ChatRecordVideo') {
              if (typeof v.content === 'string') {
                const arr = JSON.parse(v.content)
                const md5 = JSON.parse(v.content).md5sum
                if (md5 || md5 !== '') {
                  const res = await this.getFile(md5)
                  if (!res.path.includes('http')) {
                    arr.url_path = FILEURL + res.path
                  } else {
                    arr.url_path = res.path
                  }
                }
                v.content = arr
              }
            } else if (v.type === 'ChatRecordFile') {
              if (typeof v.content === 'string') {
                const arr = JSON.parse(v.content)
                const md5 = JSON.parse(v.content).md5sum
                if (md5 || md5 !== '') {
                  const res = await this.getFile(md5)
                  if (!res.path.includes('http')) {
                    arr.url_path = FILEURL + res.path
                  } else {
                    arr.url_path = res.path
                  }
                }
                v.content = arr
              }
            } else if (v.type === 'ChatRecordImage' || v.type === 'emotion') {
              if (typeof v.content === 'string') {
                let arr = JSON.parse(v.content)
                const md5 = JSON.parse(v.content).md5sum
                if (md5 || md5 !== '') {
                  const res = await this.getFile(md5)
                  if (!res.path.includes('http')) {
                    arr = {
                      url_path: FILEURL + res.path
                    }
                  } else {
                     arr = {
                      url_path: res.path
                    }
                  }
                }
                v.content = arr
                this.srcList_image.push(v.content.url_path)
              }
            } else if (v.type === 'ChatRecordMixed') {
              if (typeof v.content === 'string') {
                let arr = JSON.parse(v.content).item
                arr.forEach(async k => {
                  if (k.type === 'image' || k.type === 'emotion') {
                    const md5 = JSON.parse(k.content).md5sum
                    if (md5 || md5 !== '') {
                      const res = await this.getFile(md5)
                      if (!res.path.includes('http')) {
                        k.content = {
                          url_path: FILEURL + res.path
                        }
                      } else {
                        k.content = {
                          url_path: res.path
                        }
                      }
                    }
                    this.srcList_image.push(k.content.url_path)
                  }
                })
                v.content = arr
              }
            }
          })
          this.chatrecord = data
          this.firstRecord = true
        } catch (error) {
        }
      }
    },
    closeDialog() {
      this.firstRecord = false
    },
    strMarkAll(str) {
      let newStr = str
      this.keywords.forEach(v => {
        // if (String(newStr).includes(v)) {
        if (
          String(newStr)
            .toLowerCase()
            .includes(v.toLowerCase())
        ) {
          const index = String(newStr)
            .toLowerCase()
            .indexOf(v.toLowerCase())

          const newword = String(newStr).slice(index, index + v.length)
          var reg = new RegExp(v, 'gi')
          newStr = newStr.replace(reg, `<span class="text-sign">${newword}</span>`)
        }
      })
      return newStr
    },
    // 下载语音
    download01(item) {
      this.isDownload = true;
      window.open(item.content.web_url)
    },
// 下载文件到服务器
    download02(md5) {
     // console.log(md5)
      this.isDownload = true;
      this.getFile2(md5)
      this.$message.success('下载的文件请到菜单栏中的【下载中心】去下载')
    },
    download04(item) {
      this.share_data = []
      const data = item.content.share_data
      this.dialogVisible04 = true
      this.share_data = Object.values(data)
      for (let i = 0; i <this.share_data.length; i++) {
        if (!this.share_data[i].web_url) {
          this.shareChi = this.shareChi + 1
        }
      }
    },
    getwen01(item) {
     const url = item.web_url
     if (url) {
      this.$confirm('是否下载该文件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning',
        closeOnClickModal: false
      })
      .then(() => {
        if (url !== '') {
          if (url.includes('http')) {
            window.open(url)
          } else {
            window.open(FILEURL + url)
          }
        } else {
          this.$message.warning('数据正在同步中，请稍后重新进入查看')
        }
      })
    }
    },
    // 下载文件
    download(md5) {
      // const url = item.content.web_url || item.content.url_path
      // const name = item.content.filename
      // const afterTenTime = this.$moment(this.$moment(item.msg_date).add(10, 'm')).format(
      //   'YYYY-MM-DD HH:mm:ss'
      // )
      // const isAfter = this.$moment(afterTenTime).isBefore()
      // if (isAfter) {
        this.$confirm('是否下载该文件？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            // if (url !== '') {
              this.getFile2(md5)
              this.$message.success('下载的文件请到菜单栏中的【下载中心】去下载')
              // const a = document.createElement('a')
              // a.href = url
              // alert(url)
              // if (url.includes('http')) {
              //   window.open(url)
                // downloadFile(url, item.content.filename)
              // } else {
              //   window.open(FILEURL + url)
              //   // downloadFile(FILEURL + url, item.content.filename)
              // }
            // } else {
            //   this.getFile2(md5)
            //   this.$message.success('下载的文件请到菜单栏中的【下载中心】去下载')
              //this.$message.warning('数据正在同步中，请稍后重新进入查看')
            // }
          })
      // } else {
      //   this.$message.info('文件存档中请稍后再试')
      // }
    },
    // // 获取全部敏感词匹配规则
    // getWord() {
    //   this.$api.get('/api/all/keywords').then(res => {
    //     this.keywords = res.data
    //     if (this.maskText) {
    //       this.keywords.push(this.maskText)
    //     }
    //   })
    // },
    // 获取混合消息的文件
    async getFile(md5sum) {
      try {
        const file = await this.$api.get('/api/system/get/file', {
          md5sum
        })
        if (file) {
          // return file[0].url_path
          return file
        } else {
          return ''
        }
      } catch (error) {
      }
    },
    async getFile2(md5sum) {
      try {
        const file = await this.$api.get('/api/system/get/file2', {
          md5sum
        })
        if (file) {
          // return file[0].url_path
          return file
        } else {
          return ''
        }
      } catch (error) {
      }
    },
    meetShow(msg_id, msg_date) {
      this.percentage = []
      this.percentage2 = []
      this.percentage3 = []
      this.meetList = []
      this.w = []
      this.time_sh = msg_date
       this.$api
        .get('/api/system/type/data/details', {
          msg_id: msg_id,
        }).then(
          res => {
            this.meetData = res.data
            const arr = res.user_data
            this.result = res.handle_arr.length + '人已处理'
            this.county = res.no_handle_arr.length + '人未处理'
            this.meetTitle = JSON.parse(this.meetData[0].content)
            res.status_data.forEach(c => {
              if(c.status === 1) {
                this.accpt = c.ratio
              } else if (c.status === 2) {
                this.upaccpt = c.ratio
              } else if (c.status === 3) {
                this.zan = c.ratio
              }
            })
            this.people = res.initiate_user.name
          //  this.contData = JSON.parse(this.meetData[1].content)
            const q = res.data[0].form_id
            arr.forEach(a => {
              if (q === a.user_id){
                this.percentage.push(a.name)
              }
            })
            res.no_handle_arr.forEach(o => {
              res.user_data.forEach(p => {
                if (o === p.user_id) {
                  this.w.push(p.name)
                }
              })
            })
            for (var i = 0; i < this.meetData.length; i++) {
              if (JSON.parse(this.meetData[i].content).meetingtype === 102) {
                for (var j = 0; j < arr.length; j++) {
                  if (this.meetData[i].form_id === arr[j].user_id) {
                    if (JSON.parse(this.meetData[i].content).status === 1 ){
                      this.percentage.push(arr[j].name)
                    } else if (JSON.parse(this.meetData[i].content).status === 2 ){
                      this.percentage2.push(arr[j].name)
                    } else if (JSON.parse(this.meetData[i].content).status === 3 ){
                      this.percentage3.push(arr[j].name)
                    }
                  }
                }
              }
              if(this.meetData[i].msg_id !==  msg_id) {
                  continue
              }
              if(this.meetData[i].msg_id ===  msg_id) {
                if (JSON.parse(this.meetData[i].content).meetingtype === 101) {
                    this.dialogVisible = true
                    this.dialosible = false
                    for (var j = 0; j < arr.length; j++) {
                      this.meetList.push(arr[j].name)
                      if (this.meetData[i].form_id === arr[j].user_id) {
                      }
                  }
                }else{
                  this.dialogVisible = false
                  this.dialosible = true
                  for (var j = 0; j < arr.length; j++) {
                    this.meetList.push(arr[j].name)
                   if (this.meetData[i].form_id === arr[j].user_id) {
                    if (JSON.parse(this.meetData[i].content).status === 1) {
                      this.meetStatus = JSON.parse(this.meetData[i].content).status
                    }
                    if (JSON.parse(this.meetData[i].content).status === 2) {
                      this.meetStatus = JSON.parse(this.meetData[i].content).status
                    }
                    if (JSON.parse(this.meetData[i].content).status === 3) {
                      this.meetStatus = JSON.parse(this.meetData[i].content).status
                      }
                    }
                  }
                }
              }
            }
          })
    },
    getCalendar(msg_id) {
      this.jdsi = []
      this.riTitle = []
      this.msgDDate = ''
      this.calTitle.attendeename = []
      this.dialosible01 = true
      this.$api
        .get('/api/system/type/data/details', {
          msg_id: msg_id,
        }).then(res => {
          this.msgDDate = res.data.msg_date
          this.calTitle = JSON.parse(res.data.content)
          const s = JSON.parse(res.data.content).title
          if (s.length > 22) {
            this.riTitle = s.slice(0, 22) + '...'
          } else {
            this.riTitle = s
          }
        })

    },
    getImages(content) {
      if (content.web_url === '') {
        this.$message.warning('数据正在同步中，请稍后重新进入查看')
      }
    },
    goWen(url) {
      window.open(url)
    },
    touPiao(msg_id) {
      this.tou = true
      this.wei = []
      this.n = []
      this.$api
        .get('/api/system/type/data/details', {
          msg_id: msg_id,
        }).then(
          res => {
            const a = JSON.parse(res.data[0].content).votetitle
            if (a.length > 22) {
              this.touTitle = a.slice(0, 22) + '...'
            } else {
              this.touTitle = a
            }
            this.msg_time = res.data[0].msg_data
            this.result01 = res.handle_arr.length
            this.result03 = res.handle_arr.length
            this.county01 = res.no_handle_arr.length
            this.touXuan = res.vote_data
            const r = res.no_handle_arr
            r.forEach(p => {
              res.user_data.forEach(o => {
                if (p === o.user_id) {
                  this.wei.push(o.name)
                }
              })
            })
            let arr = res.user_data
             arr.forEach(k => {
              if (res.data[0].form_id === k.user_id) {
                this.touPeople = k.name
              }
            })
          })
      },
      touPiao2(form_id, msg_id) {
        this.tou2 = true
        this.creatPeople= ''
        this.can = []
        this.msg_time2 = ''
        this.people_data = {}
        this.touTitle2 = []
        this.$api
        .get('/api/system/type/data/details', {
          msg_id: msg_id,
        }).then(res => {
          this.can = res.vote_data
          this.msg_time2 = res.data[0].msg_data
          const b = JSON.parse(res.data[0].content).votetitle
          if (b.length > 22) {
            this.touTitle2 = b.slice(0, 22) + '...'
          } else {
            this.touTitle2 = b
          }
          let obj = []
          res.data.forEach(p => {
            if(msg_id === p.msg_id) {
              obj = JSON.parse(p.content).voteitem
            }
          })
          obj.forEach(item=>{
            this.people_data[item] = item
          })
          this.creatPeople = res.createdName
          // let arr = res.user_data
          // arr.forEach(k => {
          //   if (form_id === k.user_id) {
          //     this.creatPeople = k.name
          //   }
          // })
        })
      },
      goLink(url) {
        window.open(url, '_blank')
      },
      goTou() {
        this.tou = false
        this.active01 = 'first'
      }
    }
}
</script>
<style lang="scss" scoped>
$dialog-bg: #f8f8f8;
.redEnvelope {
  width: 230px;
  height: 85px;
  position: relative;

  img {
    width: 230px;
    height: 85px;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
  }
  .red_body {
    position: absolute;
    top: 20px;
    left: 48px;
    z-index: 100;
    width: 170px;
    font-size: 16px;
    font-weight: 400;
    color: #ffefb9;
    display:-webkit-box;
    overflow: hidden;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
    text-overflow: ellipsis;
    word-break: break-all;
  }
  .hong{
    width: 0.8rem;
    height: 0.3rem;
    position: absolute;
    top: 75%;
    left: 90%;
  }
  .red_bottom {
    width: 230px;
    height: 30px;
    position: absolute;
    bottom: 0px;
    left: 0px;
    z-index: 100;
    font-weight: 400;
    color: hsla(46, 100%, 86%, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .cvb{
      width: 120px;
      margin-top: 10px;
      font-size: 10px;
      color: #FFEFB9;
      white-space:nowrap;
      transform:scale(0.8);
      overflow:hidden;
      text-overflow:ellipsis;

    }
    .cvb01{
      width: 120px;
      margin-top: 10px;
      font-size: 10px;
      text-align: right;
      transform:scale(0.8);
      color: #FFEFB9;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;

    }
    .cvb02{
      width: 120px;
      margin-top: 10px;
      font-size: 10px;
      text-align: left;
      transform:scale(0.8);
      color: #FFEFB9;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;

    }
  }
}
.infinite-lists {
  // padding-right: 20px;
  height: 100%;
  // overflow-y: auto;
  // overflow-x: hidden;
  .infinite-list-item {
    display: flex;
    margin: 0 0 22px -20px;
    line-height: 1.4em;

    .user-avatar {
      flex-shrink: 0;
      margin-right: 10px;
      width: 48px;
      height: 48px;
      border-radius: 2px;
      // border: 1px solid #204a9e;
    }

    .dialog-info {
      color: #909399;
      margin-bottom: 8px;

      .name {
        padding-left: 10px;
        font-size: 14px;
        color: #000000;
      }
    }

    .agree {
      text-align: center;
      display: table;
      padding: 2px 10px;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
      // background: #fff;
      // box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
      // border-radius: 2px;
      // border: 1px solid #e4e7ed;

      width: 100%;
      color: #8d99a3;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;

      img {
        position: relative;
        bottom: 1.5px;
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .toupia{
      text-align: center;
      display: table;
      padding: 2px 10px;
      height: 20px;
      font-weight: bold;
      width: 100%;
      color: #8d99a3;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
    }
    .mixed{
      max-width: 378px;
      padding: 12px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 1px rgba(2, 47, 50, 0.08);
      border-radius: 4px 4px 4px 4px;
      .text{
        margin-bottom: 8px;
      }
    }
    .voice-msg{
      width: 168px;
      height: 20px;
      // background: rgba(203, 233, 255, 0.39);
      box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
      opacity: 1;
      border-radius: 4px;
      display: flex;
      align-items: center;
      .title{
        width: 90%;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .voice-message{
       width: 240px;
       .file-wrap{
         display: flex;
         .file-name{
           width: 80%;
         }
       }
       .info-footer{
          padding-top: 6px;
          display: flex;
          align-items: center;
          margin-top: 6px;
          border-top: 1px solid #f0f1f3;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.25);
       }
    }
    .revoke {
      margin-top: 10px;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.25);

      i {
        padding-right: 5px;
      }
    }
    .msg {
      margin: 0;
      // padding: 10px;
      max-width: 375px;
      display: inline-block;
      // background: rgba(114, 163, 255, 0.2);
      // border-radius: 0px 10px 10px 10px;
      word-break: break-all;

      padding: 13px 12px;
      background: #ffffff;
      box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
      border-radius: 4px;
    }

    .icon-download {
      position: absolute;
      // top: 28px;
      right: -28px;
      cursor: pointer;
    }
    .icon-download01 {
      position: absolute;
      // top: 28px;
      left: 225px;
      cursor: pointer;
    }

    &.right {
      flex-direction: row-reverse;
      .user-avatar {
        margin: 0 0 0 10px;
      }
      .dialog-info {
        text-align: right;
      }
      .voice-icon {
        transform: rotate(180deg);
        position: relative;
      }
      .list-item-content {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      .voice-btn {
        display: flex;
        align-items: center;
        padding: 0 10px;
        max-width: 300px;
        height: 34px;
        background: hsla(205, 100%, 90%, 1);
        border-radius: 4px;
        .yuyin{
          display: flex;
          width: 100%;
          flex-direction: row-reverse;
          .rwer01{
            position: relative;
            right: 10px;
            text-align: right;
          }
        }
      }
      .msg {
        // background: rgba(114, 163, 255, 0.2);
        // border-radius: 10px 0px 10px 10px;
        word-break: break-all;
        text-align: left;
        background: #FFF;
        box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
        border-radius: 4px;
      }
      .info-card {
        text-align: left;
      }
      .icon-download {
        left: -30px;
      }
      .icon-download01 {
        left: -50px;
      }
      & .name {
        // padding: 0 15px 0 0;
        font-size: 14px;
        color: #000000;
      }
    }
    &.right::after {
      content: '';
      display: block;
      visibility: hidden;
      clear: both;
    }
  }
  .file-wrap{
    // display: flex;
    // align-items: center;
  }
  // .weapp {
  //   .weapp-info {
  //     margin-top: 10px;
  //   }
  // }
  .weapp {
    padding: 12px;
    width: 228px;
    height: 230px;
    // border: 1px solid black;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
    opacity: 1;
    border-radius: 4px;
    .weapp_name {
      width: 100%;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
    .weapp_title {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 14px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 8px;
      width: 100%;
    }
    .weappA {
      width: 228px;
      height: 170px;
      margin-top: 8px;
    }
    .weapp_bottom {
      width: 100%;
      height: 20px;
      border-top: 1px solid #f0f1f3;
      margin-top: 4px;
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
      }
      span {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
  .vote {
    width: 257px;
    max-height: 173px;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
    border-radius: 4px;
    padding: 12px;
    .zu{
      width: 100%;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
      margin-top: 16px;
    }
    .zu01{
      width: 100%;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
    }
    .vote_title {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      // line-height: 16px;
      color: rgba(0, 0, 0, 0.85);
    }
    .vote_list {
      padding:0 8px;
      background: #fafafa;
      border-radius: 2px;
      margin-top: 12px;
      div:last-child {
        border: none;
      }
      div {
        width: 100%;
        height: 38px;
        border-bottom: 1px solid #f0f1f3;
        line-height: 38px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        span {
          display: inline-block;
          width: 6px;
          height: 6px;
          border: 1px solid rgba(0, 0, 0, 0.45);
          border-radius: 50%;
          margin-right: 8px;
        }
      }
    }
    .vote_bottom {
      width: 100%;
      height: 20px;
      border-top: 1px solid #f0f1f3;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 12px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
  }
  .voice-btn {
    display: flex;
    align-items: center;
    padding: 0 10px;
    max-width: 300px;
    height: 34px;
    background: hsla(205, 100%, 90%, 1);
    border-radius: 4px;
    .yuyin{
      display: flex;
      width: 100%;
      .rwer{
        position: relative;
        left: 10px;
      }
    }
    .indownload {
        position: relative;
        top: 2px;
        left: 35px;
        cursor: pointer;
      }
  }
.voice-btn01{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}
  .file {
    width: 286px;
    height: 40px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    box-shadow: 0px 2px 10px 0px rgba(2, 47, 50, 0.1);
    border-radius: 2px;
    // border: 1px solid #e4e7ed;
    background: #fff;

    .file-name {
      color: #303133;
      text-align: left;
      width: 246px;
    }
  }
  .daiban{
    width: 224px;
    max-height: 61px;
    .info-title{
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: rgba(0,0,0,0.8500);
    }
    .dasic{
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0,0,0,0.4500);
    }
    .info-footer{
      display: flex;
      align-items: center;
      padding-top: 0;
      border-top: 1px solid hsla(220, 11%, 95%, 1);
    }
  }
  .calendar{
    width: 257px;
    height: 116px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 1px rgba(2, 47, 50, 0.08);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    .hiahd{
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      opacity: 1;
      margin-bottom: 4px;
    }
    .time {
      width: 100%;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 4px;
      font-size: 12px;
    }
    .place{
      font-size: 12px;
      font-weight: 400;
      margin-top: 16px;
      color: rgba(0, 0, 0, 0.45);
    }
    .remarks{
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
    }
    .info-footer{
      border-top: 1px solid hsla(220, 11%, 95%, 1);
      padding-top: 3px;
      font-size: 12px;
      .rqwe{
        margin-left: 2px;
        position: relative;
        top: -1px;
      }
    }
  }
  .location {
    width: 279px;
    height: 135px;
    margin-top: 20px;
    background-size: 100% 100%;
    position: relative;
    .location-text {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      color: #fff;
      box-sizing: border-box;
      .euio{
        width:.75rem;
        height: 2rem;
        position: absolute;
        left: 118px;
        top: 22px;
      }
      .address{
        width:100%;
        height: 45px;
        position: absolute;
        left: 0;
        bottom: 0;
        border-radius: 0 0 2px 2px;
        line-height: 25px;
        background: rgba(0, 0, 0, 0.5);
        .zi{
          width: 280px;
          padding: 0 .625rem;
          overflow: hidden;
          font-size: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .title{
          width:280px;
          padding: 0 .625rem;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          opacity: 0.8;
        }
      }
    }
  }

  .visiting-card {
    width: 240px;
    height: 57px;
    display: flex;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
    .info-title {
        // font-size: 16px;
        // font-weight: bold;
        width: 100%;
        font-size: 14px;
        margin-bottom: 0;
        color: rgba(0, 0, 0, 0.85);
      .fds {
        display: flex;
        width: 100%;
        margin-bottom: 8px;
        .vnfuh{
          width: 192px;
          .dsfs{
            width: 192px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            display: -webkit-box;
            overflow: hidden;
            /*! autoprefixer: off; */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            color: rgba(0, 0, 0, 0.85);
          }
          .dsfss{
            width: 192px;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            display: -webkit-box;
            overflow: hidden;
            /*! autoprefixer: off; */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
      .footer {
        border-top: 1px solid hsla(220, 11%, 95%, 1);
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.25);
      }
      .img {
        width: 40px;
        height: 40px;
        margin-left: 8px;
      }
    }
  }

  .link {
    width: 286px;
    max-height: 92px;
    padding: 8px 12px;
    .wendang{
      display: flex;
      width: 100%;
      .info-title {
        width: 246px;
        height: 16px;
        font-size: 14px;
        display: -webkit-box;
        overflow: hidden;
        /*! autoprefixer: off; */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      .link-text{
        font-size: 12px;
        font-weight: 400;
        padding-top: 4px;
        color: rgba(0,0,0,0.4500);
        z-index: 999;
      }
    }
    .info-title {
      font-size: 14px;
      max-height: 38px;
      display: -webkit-box;
      overflow: hidden;
      /*! autoprefixer: off; */
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      a {
        color: #041d34;
      }
    }
    .link-desc {
      display: flex;
      justify-content: space-between;
      .link-text {
        font-size: 12px;
        flex: 1;
        width: 100%;
        height: 100%;
        color: rgba(0, 0, 0, 0.45);
        display: -webkit-box;
        overflow: hidden;
        /*! autoprefixer: off; */
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      img {
        flex: 0 0 40px;
      }
    }
    .link-desc::after{
      border-bottom: none;
    }
  }
}
.up-btn {
  position: relative;
  left: 45%;
  // margin-top: 6px;
  // margin-bottom: 8px;
  padding-top: 0;
  padding-bottom: 0;
  width: auto;
  text-align: center;
  border: none;
  cursor: pointer;

  i {
    transform: rotate(90deg);
  }
}
.up-btn:hover{
  border: none;
}
.chatrecord-list {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}
.chatrecord-list > li {
  margin-bottom: 20px;

  & > div {
    margin-bottom: 10px;
  }
}
.wx-text {
  font-size: 14px;
  color: #46bb36;
}
.corp-text {
  font-size: 14px;
  color: rgb(255, 200, 17);
}
.info-card .info-footer{
  border-top: none;
}
::v-deep .el-link{
  display: inline;
}
.docmsg{
  width: 276px;
  height: 68px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 1px rgba(2, 47, 50, 0.08);
  opacity: 1;
  .zai{
    width: 100%;
    display: flex;
    .title{
      width: 240px;
      font-size: 14px;
      font-weight: 400;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      .sdfdas{
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .img{
      width: 40px;
      height: auto;
      text-align: right;
      // line-height: 100px;
    }
  }
  .footer{
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    border-top: 1px solid #f0f1f3;
    padding: 6px 0;
  }
}
.chatrecord{
  width: 242px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 1px rgba(2, 47, 50, 0.08);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  .title{
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    // white-space:nowrap;
    // overflow:hidden;
    // text-overflow:ellipsis;
  }
  .ssa{
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 12px;
    .dasic{
      width: 100%;
      display:-webkit-box;
      overflow: hidden;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:1;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
.vios{
  width: 200px;
  height: 277px;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(2, 47, 50, 0.08);
  .title{
    width: 90%;
    padding: 0 12px;
    height: 16px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    color: rgba(0, 0, 0, 0.85);
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .desc{
    height: 29px;
    font-size: 12px;
    padding: 0 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 24px;
    border-bottom: 1px solid #F0F1F3;
    color: rgba(0, 0, 0, 0.85);
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .bu{
    display: flex;
    height: 1.5rem;
    line-height: 24px;
    .img{
      height: 16px;
      margin-left: 12px;
      margin-top: 4px;
    }
    .zi{
      height: 12px;
      font-size: 12px;
       margin-left: 8px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.25);
      opacity: 1;
    }
  }
}
::v-deep .el-dialog .el-dialog__title{
  width: 100px;
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 600;
  color: #204A9E;
  opacity: 1;
}
.ty-fa{
  width: 100%;
  height: auto;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  opacity: 1;
  .wen{
    max-width: 78%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ty-header{
    display: flex;
    width: 100%;
    .bvcds{
      position: relative;
      left: -5px;
      top: 8px;
      width: 3px;
      height: 12px;
      background: #234C9C;
      opacity: 1;
      border-radius: 2px;
    }
    .title {
      width: 95%;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 28px;
      color: #204A9E;
      opacity: 1;
    }
    .imh{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .asdsa{
    // margin-top: 8px;
  }
}
.ty-cont{
  // width: 100%;
  background: #FAFAFA;
  opacity: 1;
  border-radius: 1px;
  font-size: 12px;
  margin-top: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.45);
  .wen{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .wen01{
    width: 100%;
    white-space: wrap;
  }
}
::v-deep .el-dialog__body{
  text-align: left;
  padding: 12px 24px;
}

.ty-ask{
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
  opacity: 1;
  .adas{
    position: absolute;
    right: 70px;
    color: rgba(0, 0, 0, 0.45);
  }
  .sgks{
    display: flex;
    width: 100%;
    .hio01{
      width: 400px;
      max-height: 145px;
      overflow: auto;
      font-size: 12px;
      font-weight: 400;
      color: hsla(0, 0%, 0%, 0.65);
    }
    .cv{
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      top: 20px;
      width: 56px;
      height: 15px;
      .btom{
        font-size: 11px;
        font-family: Source Han Sans CN-Normal, Source Han Sans CN;
        font-weight: 400;
        color: #204A9E;
      }
    }
  }
}
::v-deep .el-progress .el-progress--line{
  width: 100%;
}
.foort{
  margin-top: 12px;

  .hui{
    font-size: 12px;
    margin-left: 8px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
    opacity: 1;
  }
}
.hio{
  margin-bottom: 16px;
  font-size: 12px;
  font-weight: 400;
  color: hsla(0, 0%, 0%, 0.65);
}
::v-deep .eqwe{
  box-shadow: none;
}
::v-deep .el-divider--horizontal{
  margin: 8px 0;
}
.hioh{
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.45);
  opacity: 1;
  margin-top: 12px;
}
.indownload {
    position: relative;
    top: 2px;
    left: 30px;
    cursor: pointer;
}
.indownload02 {
    position: relative;
    top: 2px;
    right: 35px;
    cursor: pointer;
}
.fsdaf{
  position: relative;
  left: 90%;
  z-index: 998;
}
.fsdaf01{
  position: relative;
  z-index: 998;
 // left: 50%;
}
::v-deep .left{
  text-align: left;
}
::v-deep .el-dialog__header{
  border: none;
}
::v-deep.infinite-list .infinite-list-item .dialog-info{
  text-align: left;
}
::v-deep.infinite-list .infinite-list-item .msg{
  text-align: left;
}
.tong{
  display: flex;
  .hua{
    width: 50%;
    padding: 20px;
    .gdgfd{
      display: flex;
       .title{
        margin-left: 8px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #204A9E;
      }
    }
    .ming{
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
        font-size: 12px;
    }
    .wen{
      width: 240px;
      height: 56px;
      display: flex;
      padding: 12px;
      color: hsla(220, 66%, 37%, 1);
      background: rgba(250, 250, 250, 0.39);
      opacity: 1;
      .hgbn{
        width: 180px;
        height: 30px;
        // overflow: hidden;
        // text-overflow:ellipsis;
        // white-space: nowrap;
      }
      // .img{
      //   width: 32px;
      // }
    }
  }
}
.yinp{
  // display: flex;
  width: 100%;
  .bui{
    width: 100%;
    margin-bottom: 8px;
    .sdhu{
      width: 100%;
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid hsla(0, 0%, 0%, 0.1);
      .dfds{
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #204A9E;
        margin-left: 8px;
      }
      .said{
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        .mhu{
          font-size: 12px;
          margin-left: 8px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
        }
      }
      .wen{
        width: 240px;
        height: 32px;
        display: flex;
        align-items: center;
        margin-top: 8px;
        padding: 12px;
        color: hsla(220, 66%, 37%, 1);
        background: rgba(250, 250, 250, 1);
        opacity: 1;
        .hgbn{
          width: 205px;
          padding-right: 5px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .sadf{
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.45);
        }
      }
    }
  }
}
.sdfeww{
  margin-top: 24px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 24px;
  color: #041D34;
  border-bottom: 1px solid rgba(248, 248, 248, 1);
  opacity: 1;
}
::v-deep .el-tabs__active-bar{
  height: 1px;
  background-color: hsla(206, 100%, 50%, 1)
}
::v-deep .el-tabs__nav-wrap::after{
  background-color: #fff;
}
::v-deep .el-tabs__item{
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
::v-deep .el-tabs__item.is-active{
  color: #041D34;
  font-size: 14px;
  font-weight: 400;
}
::v-deep .el-progress-bar__outer{
  height: 3px;
}
::v-deep .el-progress-bar__inner{
  background-color: hsla(206, 100%, 50%, 1);
}
.ty-dfds{
  background: #FAFAFA;
  padding: 12px;
  margin-top: 20px;
  font-family: Source Han Sans CN-Normal, Source Han Sans CN;
  margin-bottom: 90px;
  .zu{
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: hsla(0, 0%, 0%, 0.45);
    opacity: 1;
    .gfd{
      font-size: 12px;
      color: hsla(0, 0%, 0%, 0.45);
    }
  }
  .zu01{
    width: 100%;
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: hsla(0, 0%, 0%, 0.45);
    margin-bottom: 8px;
    .ijdias{
      width: 52px;
    }
    .fdgfd{
      width: 470px;
      font-weight: 400;
      max-height: 120px;
      line-height: 17px;
      color: hsla(0, 0%, 0%, 0.45);
      overflow: auto;

    }
    .cv{
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      top: 20px;
      width: 56px;
      height: 15px;
      .btom{
        font-size: 11px;
        font-weight: 400;
        color: #204A9E;
      }
    }
  }
}
::v-deep .el-progress__text{
  position: relative;
  top: -17px;
  left: -20px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
